import { EnterOutlined } from '@ant-design/icons'
import { Button, Form, Input, Space, Typography } from 'antd'
import { emailRule, requiredRule } from '../../../helpers/rules'
import { OnboardingStepProps } from '../types'
import i18n from '../../../i18n/setupLocalization'
import LocalizationKeys from '../../../i18n/LocalizationKeys'

const { Title } = Typography

const EmailStep = ({ onSuccess }: OnboardingStepProps) => {
  const formInstance = Form.useFormInstance()
  const checkBeforeSuccess = (nameList: string[]) => {
    formInstance
      .validateFields(nameList)
      .then(() => onSuccess())
      .catch((e) => console.log(e))
  }

  return (
    <Space>
      <Form.Item
        validateTrigger={false}
        label={
          <Title className="m-0" level={5}>
            {i18n.t(LocalizationKeys.Page.OnboardingStepsEmailPage.Email)}
          </Title>
        }
        name={'email'}
        rules={[requiredRule(), emailRule()]}
      >
        <Input
          className="authField"
          type="email"
          size="large"
          onPressEnter={(e) => {
            e.preventDefault()
            checkBeforeSuccess(['email'])
          }}
        />
      </Form.Item>
      <Button
        size="large"
        style={{ marginTop: 8 }}
        icon={<EnterOutlined />}
        onClick={() => checkBeforeSuccess(['email'])}
      ></Button>
    </Space>
  )
}

export default EmailStep
